var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.436,
    height: 54.436,
    viewBox: "0 0 54.436 54.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#333;}.b{fill:#fff;}.c{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1512.627 -213.353)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 27.218,
    cy: 27.218,
    r: 27.218,
    transform: "translate(1512.627 213.353)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1523.493 224.24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.802 4.829)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2331.887,2420.34a1.016,1.016,0,0,1-.722-.3l-20.754-20.754a1.021,1.021,0,0,1,1.443-1.443l20.754,20.754a1.021,1.021,0,0,1-.722,1.742Z",
    transform: "translate(-2310.113 -2397.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2311.134,2420.34a1.021,1.021,0,0,1-.722-1.742l20.754-20.754a1.021,1.021,0,0,1,1.443,1.443l-20.754,20.754A1.017,1.017,0,0,1,2311.134,2420.34Z",
    transform: "translate(-2310.113 -2397.545)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 32.662,
    height: 32.662,
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.799d324fb06cd5d9a4b9c9e64b65d982.svg";
export { ForwardRef as ReactComponent };